exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ranking[data-v-61eb1ab7]{display:flex;align-items:center;justify-content:start;width:15%!important}.ranking-only-icon[data-v-61eb1ab7]{width:100%!important;align-items:center;flex-direction:column;justify-content:center!important}.ranking .info[data-v-61eb1ab7]{display:flex;flex-direction:column;align-items:center}.ranking .title-ranking[data-v-61eb1ab7]{color:#363636;text-align:center;font-size:2rem;font-weight:600;line-height:1.125}.ranking .subtitle-ranking[data-v-61eb1ab7]{line-height:normal}.card-position[data-v-61eb1ab7]{width:65px;height:65px;color:#4a4a4a;border-radius:50%;background-color:#fff;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);display:flex;align-items:center;justify-content:center;flex-shrink:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61eb1ab7","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/frpm/Benchmark.vue
// module id = 1198
// module chunks = 2